<template>
<div class="changePass">
  <el-form :model="passwordForm" :rules="passwordRules" ref="ruleForms" class="demo-ruleForm" :status-icon="true" :show-message="false">
      <el-form-item prop="curPass">
        <div class="one">
          <el-input v-model="passwordForm.curPass" placeholder=" New Password"></el-input>
        </div>
      </el-form-item>
    <el-form-item prop="newPass">
      <div class="three">
        <el-input v-model="passwordForm.newPass" placeholder="Confirm Password"></el-input>
      </div>
    </el-form-item>
    </el-form>
</div>
</template>

<script>
export default {
  name: "changePass",
  data(){
    return{
      passwordForm:{
        curPass:'',
        newPass:'',
      },
      passwordRules:{
        curPass: [
          { required: true, message: '', trigger: 'blur' }
        ],
        newPass: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      changePassRule:'',
    }
  },
  methods:{
    validateForm() {
      let flag = false
      this.$refs['ruleForms'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateClear(){
      this.$refs.ruleForms.resetFields()
    }
  }
}
</script>

<style scoped lang="less">
.changePass{
  .one{
    /deep/ .el-input__inner{
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .three{
    margin-top: -2px;
    /deep/ .el-input__inner{
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
}
</style>
